import { useRouter } from "next/router";
import useSegmentTrack from "@/hooks/useSegmentTrack";
import { BannerContainer, Banner } from "./Banner.styles";

const BadStandingBanner = () => {
  const router = useRouter();
  const { pathname } = router;
  const doSegmentTrack = useSegmentTrack();

  return (
    <BannerContainer>
      <Banner data-qa="bad-standing-banner" type="critical" open>
        <Banner.Headline>Account Disabled - Action Required.</Banner.Headline>
        <Banner.Message>
          You will not be able to bid for vehicles until resolved.
        </Banner.Message>
        {!pathname.includes("settings") && (
          <>
            <Banner.Message>Please go to</Banner.Message>
            <Banner.Link
              as="button"
              onClick={(e) => {
                e.preventDefault();
                doSegmentTrack("Settings Viewed");
                router.push("/settings");
              }}
            >
              Settings
            </Banner.Link>
            <Banner.Message>to resolve this issue.</Banner.Message>
          </>
        )}
      </Banner>
    </BannerContainer>
  );
};

export default BadStandingBanner;
